import { Button } from "@/components/ui/button";
import { Expand, Share2, Printer, Download, Settings, Trash2 } from "lucide-react";

interface ChartControlsProps {
  onFullscreen: () => void;
  onShare: () => void;
  onPrint: () => void;
  onExportPNG: () => void;
  onExportPDF: () => void;
  onOpenUnits: () => void;
  onClear: () => void;
  isFullscreen: boolean;
}

export const ChartControls = ({
  onFullscreen,
  onShare,
  onPrint,
  onExportPNG,
  onExportPDF,
  onOpenUnits,
  onClear,
  isFullscreen
}: ChartControlsProps) => (
  <div className="flex gap-2 mb-4 flex-wrap">
    <Button onClick={onFullscreen} variant="outline" size="sm">
      <Expand className="h-4 w-4 mr-2" />
      {isFullscreen ? "Exit Fullscreen" : "Expand"}
    </Button>
    <Button onClick={onShare} variant="outline" size="sm">
      <Share2 className="h-4 w-4 mr-2" />
      Share
    </Button>
    <Button onClick={onPrint} variant="outline" size="sm">
      <Printer className="h-4 w-4 mr-2" />
      Print
    </Button>
    <Button onClick={onExportPNG} variant="outline" size="sm">
      <Download className="h-4 w-4 mr-2" />
      Export PNG
    </Button>
    <Button onClick={onExportPDF} variant="outline" size="sm">
      <Download className="h-4 w-4 mr-2" />
      Export PDF
    </Button>
    <Button onClick={onOpenUnits} variant="outline" size="sm">
      <Settings className="h-4 w-4 mr-2" />
      Units
    </Button>
    <Button onClick={onClear} variant="outline" size="sm">
      <Trash2 className="h-4 w-4 mr-2" />
      Clear
    </Button>
  </div>
);
